import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import asset from 'utils/asset'
import { Link } from 'react-router-dom'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import {
  HeaderContainer,
  HeaderContent,
  RightSection,
  Logo,
  RegisterVenue,
  LoginButton,
  OrderPartyHeader,
  VenueLogo,
  BackButton,
  CorporateButton,
} from './styled'
import DesktopContainer from 'layouts/DesktopContainer'
import events from 'const/analytics-events'
import LINKS from './../../const/links'
import Profile, { DummyProfile } from 'auth/Profile'
import withAnalytics from 'enhancers/withAnalytics'
import WithAuthentication from 'global/WithAuthentication'
import withContainer from './PageHeaderContainer'
import meta from 'const/meta'
import { isOrderUrl, isVenueUrl } from 'utils/url'
import { Text } from 'components/v2/styled'
import { isWhiteLabel } from 'utils/whiteLabel'
import { VendorHeaderStatus } from 'pages/vendor/Desktop/VendorHeader/styled'
import VenueStatusOrange from 'common/VenueStatusOrange'
import { STATUS_CLOSED, STATUS_OFFLINE } from 'pages/vendor/const'
import { DesktopScreen } from 'utils/screen'
import {
  isCateringVenue,
  CATERING_REVIEW_PATH,
  CATERING_STATUS_PATH,
} from 'utils/cateringFlow'
import VenueFavouriteHandler from 'enhancers/withFavouriteVenue'
import {
  FavouriteButton,
  FavouriteIcon,
} from 'pages/vendor/Desktop/VendorHeader/styled'
import { matchPath } from 'react-router'
import { usePageHeaderCorporateButtonEnabled } from '../../utils/featureFlag'

/*
 * About <DummyProfile /> & 'dummy-authed' className
 * DummyProfile is part of a hack for performance optimization
 * When server rendered content adds the className 'dummy-authed',
 * we'll be able to show (fake) profile dropdown without having to
 * fetch (and more importantly, cache) individual user data
 */

const TrackedLink = withAnalytics([
  {
    eventType: 'onClick',
    options: events['HEADER_CLICK_LOGO'],
  },
])(Link)

const CorporateBtn = withAnalytics([
  {
    eventType: 'onClick',
    options: events['HEADER_CLICK_CORPORATE'],
  },
])(CorporateButton)

const BusinessBtn = withAnalytics([
  {
    eventType: 'onClick',
    options: events['HEADER_CLICK_BUSINESS'],
  },
])(RegisterVenue)

const LoginBtn = withAnalytics([
  {
    eventType: 'onClick',
    options: events['HEADER_CLICK_LOGIN'],
  },
])(LoginButton)

class Header extends React.Component {
  state = { isProfileOpen: false }

  openProfile = (isProfileOpen) => {
    this.setState({
      isProfileOpen,
    })
  }

  goToBusiness = () => {
    const win = window.open(LINKS.LIST_BUSINESS, '_blank')
    win.opener = null
  }

  goToCorporate = () => {
    const win = window.open(LINKS.CORPORATE, '_blank')
    win.opener = null
  }

  isOrderPage = () => {
    const { history } = this.props
    return isOrderUrl(get(history, 'location.pathname', ''))
  }

  isMenuPage = () => {
    const { history } = this.props
    return isVenueUrl(get(history, 'location.pathname', ''))
  }

  isReviewPage = () => {
    const { history } = this.props
    return !!matchPath(get(history, 'location.pathname', ''), {
      path: ['/order/:id/review', CATERING_REVIEW_PATH],
      exact: true,
    })
  }

  isStatusPage = () => {
    const { history } = this.props
    return !!matchPath(get(history, 'location.pathname', ''), {
      path: ['/order/:id/status', CATERING_STATUS_PATH],
      exact: true,
    })
  }

  componentDidMount = () => {
    const body = document.getElementsByTagName('BODY')[0]
    body.classList.remove('dummy-authed')
  }

  render() {
    const { isProfileOpen } = this.state
    const {
      customer,
      isAuthenticated,
      showLoginModal,
      authActions: { logout },
      orderParty,
      venueDetails,
      history,
    } = this.props

    const isHost = get(orderParty, 'leaderCustomerId') === get(customer, 'id')

    const status = get(venueDetails, 'status')

    // No status banner for a whitelabel catering venue: it takes orders for later.
    const isOffline =
      (status === STATUS_CLOSED || status === STATUS_OFFLINE) &&
      !isCateringVenue(venueDetails)

    const venueId = get(venueDetails, 'id')

    // The whitelabel review and status pages show the venue logo on the left.
    // The menu page shows it only for a whitelabel catering venue.
    const showWhiteLabelLogo =
      (this.isReviewPage() ||
        this.isStatusPage() ||
        (this.isMenuPage() && isCateringVenue(venueDetails))) &&
      isWhiteLabel() &&
      !!get(venueDetails, 'logoImage')

    const isPageHeaderCorporateButtonEnabled =
      usePageHeaderCorporateButtonEnabled()

    const handleBack = (e) => {
      if (!venueId) {
        e.preventDefault()
      }
    }

    return (
      <Fragment>
        {this.isMenuPage() && isOffline && (
          <DesktopScreen>
            <VendorHeaderStatus isOffline={isOffline}>
              <VenueStatusOrange position="top" />
            </VendorHeaderStatus>
          </DesktopScreen>
        )}
        <HeaderContainer
          isFixed={isProfileOpen}
          isOrderPage={this.isOrderPage()}
          hasVenueLogo={showWhiteLabelLogo}
        >
          {!isEmpty(orderParty) && !isHost && isAuthenticated && (
            <OrderPartyHeader>
              <DesktopContainer>
                {get(orderParty, 'leaderCustomerName', '').slice(0, -3)}’s group
                order - Everyone pays for themselves
              </DesktopContainer>
            </OrderPartyHeader>
          )}
          <DesktopContainer background="white">
            {/* Centre the logo vertically with the controls on the right. */}
            <HeaderContent centered={showWhiteLabelLogo}>
              {get(venueDetails, 'logoImage') &&
                !isWhiteLabel() &&
                this.isMenuPage() && (
                  <VenueLogo src={get(venueDetails, 'logoImage')}>
                    <div className="logo" />
                  </VenueLogo>
                )}
              {showWhiteLabelLogo ? (
                <Link
                  to={`/restaurant/${venueId}/menu`}
                  className={!venueId ? 'cursor-not-allowed' : ''}
                  onClick={handleBack}
                >
                  <VenueLogo src={get(venueDetails, 'logoImage')}>
                    <div className="logo" />
                  </VenueLogo>
                </Link>
              ) : (
                this.isOrderPage() && (
                  <BackButton
                    to={`/restaurant/${venueId}/menu`}
                    className={`flex items-center ${!venueId ? 'cursor-not-allowed' : ''}`}
                    onClick={handleBack}
                  >
                    <img
                      height={24}
                      width={24}
                      src={asset('images/v2/grey-back.png')}
                    />{' '}
                    <Text fontWeight="700" size="14px" color="#999">
                      Back to menu
                    </Text>
                  </BackButton>
                )
              )}
              {!this.isOrderPage() && !this.isMenuPage() && (
                <TrackedLink to="/">
                  <Logo src={asset('icons/heyyou-logo.svg')} alt={meta.title} />
                </TrackedLink>
              )}

              <RightSection>
                {!isWhiteLabel() &&
                  isPageHeaderCorporateButtonEnabled &&
                  history.location.pathname === '/' && (
                    <CorporateBtn onClick={this.goToCorporate}>
                      For corporate
                    </CorporateBtn>
                  )}
                {!isWhiteLabel() && history.location.pathname === '/' && (
                  <BusinessBtn onClick={this.goToBusiness}>
                    For venue
                  </BusinessBtn>
                )}
                {this.isMenuPage() && (
                  <VenueFavouriteHandler id={venueId}>
                    {({ isFavourite, isLoading, onClick }) => {
                      return (
                        <FavouriteButton disabled={isLoading} onClick={onClick}>
                          <FavouriteIcon
                            type={isFavourite ? 'heartFilled' : 'heart'}
                          />
                          Favourite
                        </FavouriteButton>
                      )
                    }}
                  </VenueFavouriteHandler>
                )}
                {/*
                TODO: order party
                <Wrapper>
                  <CreateOrderParty />
                </Wrapper> */}
                {isAuthenticated ? (
                  <Fragment>
                    {!isEmpty(orderParty) && !isHost && isAuthenticated && (
                      <OrderPartyHeader>
                        <DesktopContainer>
                          {get(orderParty, 'leaderCustomerName', '').slice(
                            0,
                            -3,
                          )}
                          ’s group order - Everyone pays for themselves
                        </DesktopContainer>
                      </OrderPartyHeader>
                    )}

                    <Profile
                      logout={logout}
                      openProfile={this.openProfile}
                      {...customer}
                    />
                  </Fragment>
                ) : (
                  <Fragment>
                    <DummyProfile />
                    <LoginBtn
                      variant={isWhiteLabel() ? 'whitelabel' : 'primary'}
                      onClick={showLoginModal}
                    >
                      Login
                    </LoginBtn>
                  </Fragment>
                )}
              </RightSection>
            </HeaderContent>
          </DesktopContainer>
        </HeaderContainer>
      </Fragment>
    )
  }
}

Header.propTypes = {
  customer: PropTypes.object,
  authActions: PropTypes.object,
  isAuthenticated: PropTypes.bool,
}

export default WithAuthentication(withContainer(Header))
